import { useCallback, useState } from 'react';

import { useMainMenuContext } from 'state/menu/main-menu';
import { DAY_PART_SELECTIONS, IGetDayPart, IUseDayPart } from 'state/menu/main-menu/types';

export const useDayPartSelector = (): IUseDayPart => {
  const { activeDayParts, dayParts } = useMainMenuContext();
  const [selectedDayPart, setSelectedDayPart] = useState<DAY_PART_SELECTIONS>();

  const breakfastInterval = activeDayParts.find(
    item => item?.key === DAY_PART_SELECTIONS.BREAKFAST_KEY
  );

  const mainMenuInterval = activeDayParts.find(
    item => item?.key === DAY_PART_SELECTIONS.MAIN_MENU_KEY
  );

  const getDayPart = useCallback((): IGetDayPart => {
    const daypartItems = dayParts.filter(item => item && item.key !== DAY_PART_SELECTIONS.ALL_KEY);
    return {
      currentDayPart: selectedDayPart ?? null,
      dayParts: daypartItems,
    };
  }, [dayParts, selectedDayPart]);

  return {
    breakfastInterval,
    mainMenuInterval,
    setDayPart: setSelectedDayPart,
    getDayPart,
  };
};
